export const navigate = (url: string) => {
  window.location.assign(url);
};
